import { interpolatePath } from './linkHelpers';
// PUBLIC API
export const routes = {
    OrganizationMembershipsRoute: {
        to: "/admin/organizations/:organizationId/members",
        build: (options) => interpolatePath("/admin/organizations/:organizationId/members", options.params, options?.search, options?.hash),
    },
    LandingPageRoute: {
        to: "/",
        build: (options) => interpolatePath("/", undefined, options?.search, options?.hash),
    },
    ReceptionLandingRoute: {
        to: "/reception",
        build: (options) => interpolatePath("/reception", undefined, options?.search, options?.hash),
    },
    AboutRoute: {
        to: "/about",
        build: (options) => interpolatePath("/about", undefined, options?.search, options?.hash),
    },
    PrivacyRoute: {
        to: "/privacy",
        build: (options) => interpolatePath("/privacy", undefined, options?.search, options?.hash),
    },
    TermsRoute: {
        to: "/terms",
        build: (options) => interpolatePath("/terms", undefined, options?.search, options?.hash),
    },
    RoadmapRoute: {
        to: "/roadmap",
        build: (options) => interpolatePath("/roadmap", undefined, options?.search, options?.hash),
    },
    ContactRoute: {
        to: "/contact",
        build: (options) => interpolatePath("/contact", undefined, options?.search, options?.hash),
    },
    LoginRoute: {
        to: "/login",
        build: (options) => interpolatePath("/login", undefined, options?.search, options?.hash),
    },
    SignupRoute: {
        to: "/signup",
        build: (options) => interpolatePath("/signup", undefined, options?.search, options?.hash),
    },
    RequestPasswordResetRoute: {
        to: "/request-password-reset",
        build: (options) => interpolatePath("/request-password-reset", undefined, options?.search, options?.hash),
    },
    PasswordResetRoute: {
        to: "/password-reset",
        build: (options) => interpolatePath("/password-reset", undefined, options?.search, options?.hash),
    },
    EmailVerificationRoute: {
        to: "/email-verification",
        build: (options) => interpolatePath("/email-verification", undefined, options?.search, options?.hash),
    },
    PendingApprovalRoute: {
        to: "/pending-approval",
        build: (options) => interpolatePath("/pending-approval", undefined, options?.search, options?.hash),
    },
    AccountRoute: {
        to: "/account",
        build: (options) => interpolatePath("/account", undefined, options?.search, options?.hash),
    },
    NotificationsRoute: {
        to: "/notifications",
        build: (options) => interpolatePath("/notifications", undefined, options?.search, options?.hash),
    },
    DashboardRoute: {
        to: "/dashboard",
        build: (options) => interpolatePath("/dashboard", undefined, options?.search, options?.hash),
    },
    DemoSchedulerRoute: {
        to: "/tools/scheduler",
        build: (options) => interpolatePath("/tools/scheduler", undefined, options?.search, options?.hash),
    },
    PricingPageRoute: {
        to: "/pricing",
        build: (options) => interpolatePath("/pricing", undefined, options?.search, options?.hash),
    },
    CheckoutRoute: {
        to: "/checkout",
        build: (options) => interpolatePath("/checkout", undefined, options?.search, options?.hash),
    },
    FileUploadRoute: {
        to: "/file-upload",
        build: (options) => interpolatePath("/file-upload", undefined, options?.search, options?.hash),
    },
    AdminRoute: {
        to: "/admin",
        build: (options) => interpolatePath("/admin", undefined, options?.search, options?.hash),
    },
    AdminUsersRoute: {
        to: "/admin/users",
        build: (options) => interpolatePath("/admin/users", undefined, options?.search, options?.hash),
    },
    AdminUserDetailRoute: {
        to: "/admin/users/:userId",
        build: (options) => interpolatePath("/admin/users/:userId", options.params, options?.search, options?.hash),
    },
    AdminUserEditRoute: {
        to: "/admin/users/:userId/edit",
        build: (options) => interpolatePath("/admin/users/:userId/edit", options.params, options?.search, options?.hash),
    },
    AdminUserRecycleBinRoute: {
        to: "/admin/users/recycle-bin",
        build: (options) => interpolatePath("/admin/users/recycle-bin", undefined, options?.search, options?.hash),
    },
    AdminUserApprovalsRoute: {
        to: "/admin/users/approvals",
        build: (options) => interpolatePath("/admin/users/approvals", undefined, options?.search, options?.hash),
    },
    AdminSettingsRoute: {
        to: "/admin/settings",
        build: (options) => interpolatePath("/admin/settings", undefined, options?.search, options?.hash),
    },
    AdminCalendarRoute: {
        to: "/admin/calendar",
        build: (options) => interpolatePath("/admin/calendar", undefined, options?.search, options?.hash),
    },
    AdminUIButtonsRoute: {
        to: "/admin/ui/buttons",
        build: (options) => interpolatePath("/admin/ui/buttons", undefined, options?.search, options?.hash),
    },
    AdminOrganizationTypesRoute: {
        to: "/admin/organization-types",
        build: (options) => interpolatePath("/admin/organization-types", undefined, options?.search, options?.hash),
    },
    AdminAddOrganizationTypeRoute: {
        to: "/admin/organization-types/new",
        build: (options) => interpolatePath("/admin/organization-types/new", undefined, options?.search, options?.hash),
    },
    AdminViewOrganizationTypeRoute: {
        to: "/admin/organization-types/:organizationTypeId",
        build: (options) => interpolatePath("/admin/organization-types/:organizationTypeId", options.params, options?.search, options?.hash),
    },
    AdminEditOrganizationTypeRoute: {
        to: "/admin/organization-types/:organizationTypeId/edit",
        build: (options) => interpolatePath("/admin/organization-types/:organizationTypeId/edit", options.params, options?.search, options?.hash),
    },
    AdminLocationTypesRoute: {
        to: "/admin/taxonomy/location-categories",
        build: (options) => interpolatePath("/admin/taxonomy/location-categories", undefined, options?.search, options?.hash),
    },
    AdminAddLocationTypeRoute: {
        to: "/admin/taxonomy/location-categories/new",
        build: (options) => interpolatePath("/admin/taxonomy/location-categories/new", undefined, options?.search, options?.hash),
    },
    AdminViewLocationTypeRoute: {
        to: "/admin/taxonomy/location-categories/:locationTypeId",
        build: (options) => interpolatePath("/admin/taxonomy/location-categories/:locationTypeId", options.params, options?.search, options?.hash),
    },
    AdminEditLocationTypeRoute: {
        to: "/admin/taxonomy/location-categories/:locationTypeId/edit",
        build: (options) => interpolatePath("/admin/taxonomy/location-categories/:locationTypeId/edit", options.params, options?.search, options?.hash),
    },
    AdminSectionsRoute: {
        to: "/admin/sections",
        build: (options) => interpolatePath("/admin/sections", undefined, options?.search, options?.hash),
    },
    AdminAddSectionRoute: {
        to: "/admin/sections/new",
        build: (options) => interpolatePath("/admin/sections/new", undefined, options?.search, options?.hash),
    },
    AdminViewSectionRoute: {
        to: "/admin/sections/:sectionId",
        build: (options) => interpolatePath("/admin/sections/:sectionId", options.params, options?.search, options?.hash),
    },
    AdminEditSectionRoute: {
        to: "/admin/sections/:sectionId/edit",
        build: (options) => interpolatePath("/admin/sections/:sectionId/edit", options.params, options?.search, options?.hash),
    },
    AdminServiceTypesRoute: {
        to: "/admin/service-types",
        build: (options) => interpolatePath("/admin/service-types", undefined, options?.search, options?.hash),
    },
    AdminServiceTypesNewRoute: {
        to: "/admin/service-types/new",
        build: (options) => interpolatePath("/admin/service-types/new", undefined, options?.search, options?.hash),
    },
    AdminServiceDefinitionsRoute: {
        to: "/admin/service-definitions",
        build: (options) => interpolatePath("/admin/service-definitions", undefined, options?.search, options?.hash),
    },
    AdminServiceDefinitionsNewRoute: {
        to: "/admin/service-definitions/new",
        build: (options) => interpolatePath("/admin/service-definitions/new", undefined, options?.search, options?.hash),
    },
    AdminTopicTypesRoute: {
        to: "/admin/topic-types",
        build: (options) => interpolatePath("/admin/topic-types", undefined, options?.search, options?.hash),
    },
    AdminTopicTypesNewRoute: {
        to: "/admin/topic-types/new",
        build: (options) => interpolatePath("/admin/topic-types/new", undefined, options?.search, options?.hash),
    },
    AdminTopicsRoute: {
        to: "/admin/topics",
        build: (options) => interpolatePath("/admin/topics", undefined, options?.search, options?.hash),
    },
    AdminTopicsNewRoute: {
        to: "/admin/topics/new",
        build: (options) => interpolatePath("/admin/topics/new", undefined, options?.search, options?.hash),
    },
    AdminOccasionTypesRoute: {
        to: "/admin/occasion-types",
        build: (options) => interpolatePath("/admin/occasion-types", undefined, options?.search, options?.hash),
    },
    AdminOccasionsRoute: {
        to: "/admin/occasions",
        build: (options) => interpolatePath("/admin/occasions", undefined, options?.search, options?.hash),
    },
    AdminOrganizationsRoute: {
        to: "/admin/organizations",
        build: (options) => interpolatePath("/admin/organizations", undefined, options?.search, options?.hash),
    },
    AdminAddOrganizationRoute: {
        to: "/admin/organizations/new",
        build: (options) => interpolatePath("/admin/organizations/new", undefined, options?.search, options?.hash),
    },
    AdminViewOrganizationRoute: {
        to: "/admin/organizations/:organizationId",
        build: (options) => interpolatePath("/admin/organizations/:organizationId", options.params, options?.search, options?.hash),
    },
    AdminEditOrganizationRoute: {
        to: "/admin/organizations/:organizationId/edit",
        build: (options) => interpolatePath("/admin/organizations/:organizationId/edit", options.params, options?.search, options?.hash),
    },
    AdminFieldConfigsRoute: {
        to: "/admin/field-configs",
        build: (options) => interpolatePath("/admin/field-configs", undefined, options?.search, options?.hash),
    },
    AdminAddFieldConfigRoute: {
        to: "/admin/field-configs/new",
        build: (options) => interpolatePath("/admin/field-configs/new", undefined, options?.search, options?.hash),
    },
    AdminEditFieldConfigRoute: {
        to: "/admin/field-configs/:id/edit",
        build: (options) => interpolatePath("/admin/field-configs/:id/edit", options.params, options?.search, options?.hash),
    },
    AdminGlobalSettingsRoute: {
        to: "/admin/global-settings",
        build: (options) => interpolatePath("/admin/global-settings", undefined, options?.search, options?.hash),
    },
    UserRolesRoute: {
        to: "/admin/user-roles",
        build: (options) => interpolatePath("/admin/user-roles", undefined, options?.search, options?.hash),
    },
    AdminTaxonomyRoute: {
        to: "/admin/taxonomy",
        build: (options) => interpolatePath("/admin/taxonomy", undefined, options?.search, options?.hash),
    },
    AdminMessagesRoute: {
        to: "/admin/messages",
        build: (options) => interpolatePath("/admin/messages", undefined, options?.search, options?.hash),
    },
    TestDashboardRoute: {
        to: "/test-dashboard",
        build: (options) => interpolatePath("/test-dashboard", undefined, options?.search, options?.hash),
    },
    OrganizationsByTypeRoute: {
        to: "/organization-types/:typeKey/organizations",
        build: (options) => interpolatePath("/organization-types/:typeKey/organizations", options.params, options?.search, options?.hash),
    },
    OrganizationProfileRoute: {
        to: "/org/:slug",
        build: (options) => interpolatePath("/org/:slug", options.params, options?.search, options?.hash),
    },
    OrgAboutRoute: {
        to: "/org/:slug/about",
        build: (options) => interpolatePath("/org/:slug/about", options.params, options?.search, options?.hash),
    },
    OrgNoticeBoardRoute: {
        to: "/org/:slug/notices",
        build: (options) => interpolatePath("/org/:slug/notices", options.params, options?.search, options?.hash),
    },
    OrgEventsRoute: {
        to: "/org/:slug/events",
        build: (options) => interpolatePath("/org/:slug/events", options.params, options?.search, options?.hash),
    },
    OrgTenantsRoute: {
        to: "/org/:slug/tenants",
        build: (options) => interpolatePath("/org/:slug/tenants", options.params, options?.search, options?.hash),
    },
    OrgFoodCourtRoute: {
        to: "/org/:slug/food-court",
        build: (options) => interpolatePath("/org/:slug/food-court", options.params, options?.search, options?.hash),
    },
    OrgFacilitiesRoute: {
        to: "/org/:slug/facilities",
        build: (options) => interpolatePath("/org/:slug/facilities", options.params, options?.search, options?.hash),
    },
    OrgServicesRoute: {
        to: "/org/:slug/services",
        build: (options) => interpolatePath("/org/:slug/services", options.params, options?.search, options?.hash),
    },
    OrgBuySellRoute: {
        to: "/org/:slug/buy-sell",
        build: (options) => interpolatePath("/org/:slug/buy-sell", options.params, options?.search, options?.hash),
    },
    OrgBuySellAddRoute: {
        to: "/org/:slug/buy-sell/add",
        build: (options) => interpolatePath("/org/:slug/buy-sell/add", options.params, options?.search, options?.hash),
    },
    OrgRequestOfferRoute: {
        to: "/org/:slug/request-offer",
        build: (options) => interpolatePath("/org/:slug/request-offer", options.params, options?.search, options?.hash),
    },
    OrgRequestOfferAddRoute: {
        to: "/org/:slug/request-offer/add",
        build: (options) => interpolatePath("/org/:slug/request-offer/add", options.params, options?.search, options?.hash),
    },
    OrgLostFoundRoute: {
        to: "/org/:slug/lost-found",
        build: (options) => interpolatePath("/org/:slug/lost-found", options.params, options?.search, options?.hash),
    },
    OrgLostFoundAddRoute: {
        to: "/org/:slug/lost-found/add",
        build: (options) => interpolatePath("/org/:slug/lost-found/add", options.params, options?.search, options?.hash),
    },
    OrgTransportationRoute: {
        to: "/org/:slug/transportation",
        build: (options) => interpolatePath("/org/:slug/transportation", options.params, options?.search, options?.hash),
    },
    OrgTransportationAddRoute: {
        to: "/org/:slug/transportation/add",
        build: (options) => interpolatePath("/org/:slug/transportation/add", options.params, options?.search, options?.hash),
    },
    LocationProfileRoute: {
        to: "/:slug",
        build: (options) => interpolatePath("/:slug", options.params, options?.search, options?.hash),
    },
    LocationAboutRoute: {
        to: "/:slug/about",
        build: (options) => interpolatePath("/:slug/about", options.params, options?.search, options?.hash),
    },
    LocationInformationDeskRoute: {
        to: "/:slug/information-desk",
        build: (options) => interpolatePath("/:slug/information-desk", options.params, options?.search, options?.hash),
    },
    LocationNoticeBoardRoute: {
        to: "/:slug/notices",
        build: (options) => interpolatePath("/:slug/notices", options.params, options?.search, options?.hash),
    },
    LocationNoticeAddRoute: {
        to: "/:slug/notices/add",
        build: (options) => interpolatePath("/:slug/notices/add", options.params, options?.search, options?.hash),
    },
    LocationViewNoticeRoute: {
        to: "/:slug/notices/:noticeId",
        build: (options) => interpolatePath("/:slug/notices/:noticeId", options.params, options?.search, options?.hash),
    },
    LocationEditNoticeRoute: {
        to: "/:slug/notices/:noticeId/edit",
        build: (options) => interpolatePath("/:slug/notices/:noticeId/edit", options.params, options?.search, options?.hash),
    },
    LocationEventsRoute: {
        to: "/:slug/events",
        build: (options) => interpolatePath("/:slug/events", options.params, options?.search, options?.hash),
    },
    LocationFlagshipEventsRoute: {
        to: "/:slug/events/flagship",
        build: (options) => interpolatePath("/:slug/events/flagship", options.params, options?.search, options?.hash),
    },
    LocationEventsAddRoute: {
        to: "/:slug/events/add",
        build: (options) => interpolatePath("/:slug/events/add", options.params, options?.search, options?.hash),
    },
    LocationViewEventRoute: {
        to: "/:slug/events/:eventId",
        build: (options) => interpolatePath("/:slug/events/:eventId", options.params, options?.search, options?.hash),
    },
    LocationEditEventRoute: {
        to: "/:slug/events/:eventId/edit",
        build: (options) => interpolatePath("/:slug/events/:eventId/edit", options.params, options?.search, options?.hash),
    },
    LocationTenantsRoute: {
        to: "/:slug/tenants",
        build: (options) => interpolatePath("/:slug/tenants", options.params, options?.search, options?.hash),
    },
    LocationTenantsAddRoute: {
        to: "/:slug/tenants/add",
        build: (options) => interpolatePath("/:slug/tenants/add", options.params, options?.search, options?.hash),
    },
    LocationViewTenantRoute: {
        to: "/:slug/tenants/:tenantId",
        build: (options) => interpolatePath("/:slug/tenants/:tenantId", options.params, options?.search, options?.hash),
    },
    LocationEditTenantRoute: {
        to: "/:slug/tenants/:tenantId/edit",
        build: (options) => interpolatePath("/:slug/tenants/:tenantId/edit", options.params, options?.search, options?.hash),
    },
    LocationFoodCourtRoute: {
        to: "/:slug/food-court",
        build: (options) => interpolatePath("/:slug/food-court", options.params, options?.search, options?.hash),
    },
    LocationFoodCourtAddRoute: {
        to: "/:slug/food-court/add",
        build: (options) => interpolatePath("/:slug/food-court/add", options.params, options?.search, options?.hash),
    },
    LocationViewFoodCourtRoute: {
        to: "/:slug/food-court/:itemId",
        build: (options) => interpolatePath("/:slug/food-court/:itemId", options.params, options?.search, options?.hash),
    },
    LocationEditFoodCourtRoute: {
        to: "/:slug/food-court/:itemId/edit",
        build: (options) => interpolatePath("/:slug/food-court/:itemId/edit", options.params, options?.search, options?.hash),
    },
    LocationFacilitiesRoute: {
        to: "/:slug/facilities",
        build: (options) => interpolatePath("/:slug/facilities", options.params, options?.search, options?.hash),
    },
    LocationFacilitiesAddRoute: {
        to: "/:slug/facilities/add",
        build: (options) => interpolatePath("/:slug/facilities/add", options.params, options?.search, options?.hash),
    },
    LocationViewFacilityRoute: {
        to: "/:slug/facilities/:facilityId",
        build: (options) => interpolatePath("/:slug/facilities/:facilityId", options.params, options?.search, options?.hash),
    },
    LocationEditFacilityRoute: {
        to: "/:slug/facilities/:facilityId/edit",
        build: (options) => interpolatePath("/:slug/facilities/:facilityId/edit", options.params, options?.search, options?.hash),
    },
    LocationServicesRoute: {
        to: "/:slug/services",
        build: (options) => interpolatePath("/:slug/services", options.params, options?.search, options?.hash),
    },
    LocationServicesAddRoute: {
        to: "/:slug/services/add",
        build: (options) => interpolatePath("/:slug/services/add", options.params, options?.search, options?.hash),
    },
    LocationViewServiceRoute: {
        to: "/:slug/services/:itemId",
        build: (options) => interpolatePath("/:slug/services/:itemId", options.params, options?.search, options?.hash),
    },
    LocationEditServiceRoute: {
        to: "/:slug/services/:itemId/edit",
        build: (options) => interpolatePath("/:slug/services/:itemId/edit", options.params, options?.search, options?.hash),
    },
    LocationBuySellRoute: {
        to: "/:slug/buy-sell",
        build: (options) => interpolatePath("/:slug/buy-sell", options.params, options?.search, options?.hash),
    },
    LocationBuySellAddRoute: {
        to: "/:slug/buy-sell/add",
        build: (options) => interpolatePath("/:slug/buy-sell/add", options.params, options?.search, options?.hash),
    },
    LocationViewBuySellRoute: {
        to: "/:slug/buy-sell/:itemId",
        build: (options) => interpolatePath("/:slug/buy-sell/:itemId", options.params, options?.search, options?.hash),
    },
    LocationEditBuySellRoute: {
        to: "/:slug/buy-sell/:itemId/edit",
        build: (options) => interpolatePath("/:slug/buy-sell/:itemId/edit", options.params, options?.search, options?.hash),
    },
    LocationRequestOfferRoute: {
        to: "/:slug/request-offer",
        build: (options) => interpolatePath("/:slug/request-offer", options.params, options?.search, options?.hash),
    },
    LocationRequestOfferAddRoute: {
        to: "/:slug/request-offer/add",
        build: (options) => interpolatePath("/:slug/request-offer/add", options.params, options?.search, options?.hash),
    },
    LocationViewRequestOfferRoute: {
        to: "/:slug/request-offer/:itemId",
        build: (options) => interpolatePath("/:slug/request-offer/:itemId", options.params, options?.search, options?.hash),
    },
    LocationEditRequestOfferRoute: {
        to: "/:slug/request-offer/:itemId/edit",
        build: (options) => interpolatePath("/:slug/request-offer/:itemId/edit", options.params, options?.search, options?.hash),
    },
    LocationLostFoundRoute: {
        to: "/:slug/lost-found",
        build: (options) => interpolatePath("/:slug/lost-found", options.params, options?.search, options?.hash),
    },
    LocationLostFoundAddRoute: {
        to: "/:slug/lost-found/add",
        build: (options) => interpolatePath("/:slug/lost-found/add", options.params, options?.search, options?.hash),
    },
    LocationViewLostFoundRoute: {
        to: "/:slug/lost-found/:itemId",
        build: (options) => interpolatePath("/:slug/lost-found/:itemId", options.params, options?.search, options?.hash),
    },
    LocationEditLostFoundRoute: {
        to: "/:slug/lost-found/:itemId/edit",
        build: (options) => interpolatePath("/:slug/lost-found/:itemId/edit", options.params, options?.search, options?.hash),
    },
    LocationTransportationRoute: {
        to: "/:slug/transportation",
        build: (options) => interpolatePath("/:slug/transportation", options.params, options?.search, options?.hash),
    },
    LocationTransportationAddRoute: {
        to: "/:slug/transportation/add",
        build: (options) => interpolatePath("/:slug/transportation/add", options.params, options?.search, options?.hash),
    },
    LocationViewTransportationRoute: {
        to: "/:slug/transportation/:itemId",
        build: (options) => interpolatePath("/:slug/transportation/:itemId", options.params, options?.search, options?.hash),
    },
    LocationEditTransportationRoute: {
        to: "/:slug/transportation/:itemId/edit",
        build: (options) => interpolatePath("/:slug/transportation/:itemId/edit", options.params, options?.search, options?.hash),
    },
    OrganizationsRoute: {
        to: "/organizations",
        build: (options) => interpolatePath("/organizations", undefined, options?.search, options?.hash),
    },
    AdminLocationsRoute: {
        to: "/admin/taxonomy/location-names",
        build: (options) => interpolatePath("/admin/taxonomy/location-names", undefined, options?.search, options?.hash),
    },
    ViewLocationRoute: {
        to: "/admin/taxonomy/location-names/:id",
        build: (options) => interpolatePath("/admin/taxonomy/location-names/:id", options.params, options?.search, options?.hash),
    },
    CreateLocationRoute: {
        to: "/admin/taxonomy/location-names/new",
        build: (options) => interpolatePath("/admin/taxonomy/location-names/new", undefined, options?.search, options?.hash),
    },
    EditLocationRoute: {
        to: "/admin/taxonomy/location-names/:id/edit",
        build: (options) => interpolatePath("/admin/taxonomy/location-names/:id/edit", options.params, options?.search, options?.hash),
    },
    AdminLocationItemsRoute: {
        to: "/admin/taxonomy/location-names/:id/items",
        build: (options) => interpolatePath("/admin/taxonomy/location-names/:id/items", options.params, options?.search, options?.hash),
    },
    EventsRoute: {
        to: "/events",
        build: (options) => interpolatePath("/events", undefined, options?.search, options?.hash),
    },
    FlagshipEventsRoute: {
        to: "/events/flagship",
        build: (options) => interpolatePath("/events/flagship", undefined, options?.search, options?.hash),
    },
    AddEventRoute: {
        to: "/events/add",
        build: (options) => interpolatePath("/events/add", undefined, options?.search, options?.hash),
    },
    EditEventRoute: {
        to: "/events/:eventId/edit",
        build: (options) => interpolatePath("/events/:eventId/edit", options.params, options?.search, options?.hash),
    },
    ViewEventRoute: {
        to: "/events/:eventId",
        build: (options) => interpolatePath("/events/:eventId", options.params, options?.search, options?.hash),
    },
    TenantsRoute: {
        to: "/tenants",
        build: (options) => interpolatePath("/tenants", undefined, options?.search, options?.hash),
    },
    AddTenantRoute: {
        to: "/tenants/add",
        build: (options) => interpolatePath("/tenants/add", undefined, options?.search, options?.hash),
    },
    EditTenantRoute: {
        to: "/tenants/:tenantId/edit",
        build: (options) => interpolatePath("/tenants/:tenantId/edit", options.params, options?.search, options?.hash),
    },
    ViewTenantRoute: {
        to: "/tenants/:tenantId",
        build: (options) => interpolatePath("/tenants/:tenantId", options.params, options?.search, options?.hash),
    },
    NoticeBoardRoute: {
        to: "/notices",
        build: (options) => interpolatePath("/notices", undefined, options?.search, options?.hash),
    },
    AddNoticeRoute: {
        to: "/notices/add",
        build: (options) => interpolatePath("/notices/add", undefined, options?.search, options?.hash),
    },
    EditNoticeRoute: {
        to: "/notices/:noticeId/edit",
        build: (options) => interpolatePath("/notices/:noticeId/edit", options.params, options?.search, options?.hash),
    },
    ViewNoticeRoute: {
        to: "/notices/:noticeId",
        build: (options) => interpolatePath("/notices/:noticeId", options.params, options?.search, options?.hash),
    },
    FacilitiesRoute: {
        to: "/facilities",
        build: (options) => interpolatePath("/facilities", undefined, options?.search, options?.hash),
    },
    AddFacilityRoute: {
        to: "/facilities/add",
        build: (options) => interpolatePath("/facilities/add", undefined, options?.search, options?.hash),
    },
    EditFacilityRoute: {
        to: "/facilities/:facilityId/edit",
        build: (options) => interpolatePath("/facilities/:facilityId/edit", options.params, options?.search, options?.hash),
    },
    ViewFacilityRoute: {
        to: "/facilities/:facilityId",
        build: (options) => interpolatePath("/facilities/:facilityId", options.params, options?.search, options?.hash),
    },
    BuySellRoute: {
        to: "/buy-sell",
        build: (options) => interpolatePath("/buy-sell", undefined, options?.search, options?.hash),
    },
    AddBuySellRoute: {
        to: "/buy-sell/add",
        build: (options) => interpolatePath("/buy-sell/add", undefined, options?.search, options?.hash),
    },
    EditBuySellRoute: {
        to: "/buy-sell/:itemId/edit",
        build: (options) => interpolatePath("/buy-sell/:itemId/edit", options.params, options?.search, options?.hash),
    },
    ViewBuySellRoute: {
        to: "/buy-sell/:itemId",
        build: (options) => interpolatePath("/buy-sell/:itemId", options.params, options?.search, options?.hash),
    },
    FoodCourtRoute: {
        to: "/food-court",
        build: (options) => interpolatePath("/food-court", undefined, options?.search, options?.hash),
    },
    AddFoodCourtRoute: {
        to: "/food-court/add",
        build: (options) => interpolatePath("/food-court/add", undefined, options?.search, options?.hash),
    },
    EditFoodCourtRoute: {
        to: "/food-court/:itemId/edit",
        build: (options) => interpolatePath("/food-court/:itemId/edit", options.params, options?.search, options?.hash),
    },
    ViewFoodCourtRoute: {
        to: "/food-court/:itemId",
        build: (options) => interpolatePath("/food-court/:itemId", options.params, options?.search, options?.hash),
    },
    RequestOfferRoute: {
        to: "/request-offer",
        build: (options) => interpolatePath("/request-offer", undefined, options?.search, options?.hash),
    },
    AddRequestOfferRoute: {
        to: "/request-offer/add",
        build: (options) => interpolatePath("/request-offer/add", undefined, options?.search, options?.hash),
    },
    EditRequestOfferRoute: {
        to: "/request-offer/:itemId/edit",
        build: (options) => interpolatePath("/request-offer/:itemId/edit", options.params, options?.search, options?.hash),
    },
    ViewRequestOfferRoute: {
        to: "/request-offer/:itemId",
        build: (options) => interpolatePath("/request-offer/:itemId", options.params, options?.search, options?.hash),
    },
    TransportationRoute: {
        to: "/transportation",
        build: (options) => interpolatePath("/transportation", undefined, options?.search, options?.hash),
    },
    AddTransportationRoute: {
        to: "/transportation/add",
        build: (options) => interpolatePath("/transportation/add", undefined, options?.search, options?.hash),
    },
    EditTransportationRoute: {
        to: "/transportation/:itemId/edit",
        build: (options) => interpolatePath("/transportation/:itemId/edit", options.params, options?.search, options?.hash),
    },
    ViewTransportationRoute: {
        to: "/transportation/:itemId",
        build: (options) => interpolatePath("/transportation/:itemId", options.params, options?.search, options?.hash),
    },
    LostFoundRoute: {
        to: "/lost-found",
        build: (options) => interpolatePath("/lost-found", undefined, options?.search, options?.hash),
    },
    AddLostFoundRoute: {
        to: "/lost-found/add",
        build: (options) => interpolatePath("/lost-found/add", undefined, options?.search, options?.hash),
    },
    EditLostFoundRoute: {
        to: "/lost-found/:itemId/edit",
        build: (options) => interpolatePath("/lost-found/:itemId/edit", options.params, options?.search, options?.hash),
    },
    ViewLostFoundRoute: {
        to: "/lost-found/:itemId",
        build: (options) => interpolatePath("/lost-found/:itemId", options.params, options?.search, options?.hash),
    },
    ServicesRoute: {
        to: "/services",
        build: (options) => interpolatePath("/services", undefined, options?.search, options?.hash),
    },
    AddServiceRoute: {
        to: "/services/add",
        build: (options) => interpolatePath("/services/add", undefined, options?.search, options?.hash),
    },
    EditServiceRoute: {
        to: "/services/:itemId/edit",
        build: (options) => interpolatePath("/services/:itemId/edit", options.params, options?.search, options?.hash),
    },
    ViewServiceRoute: {
        to: "/services/:itemId",
        build: (options) => interpolatePath("/services/:itemId", options.params, options?.search, options?.hash),
    },
    SearchRoute: {
        to: "/search",
        build: (options) => interpolatePath("/search", undefined, options?.search, options?.hash),
    },
    OccasionsRoute: {
        to: "/occasions",
        build: (options) => interpolatePath("/occasions", undefined, options?.search, options?.hash),
    },
    OccasionDetailRoute: {
        to: "/occasions/:slug",
        build: (options) => interpolatePath("/occasions/:slug", options.params, options?.search, options?.hash),
    },
    TopicsRoute: {
        to: "/topics",
        build: (options) => interpolatePath("/topics", undefined, options?.search, options?.hash),
    },
    TopicDetailRoute: {
        to: "/topics/:slug",
        build: (options) => interpolatePath("/topics/:slug", options.params, options?.search, options?.hash),
    },
    ServiceDiscoveryRoute: {
        to: "/discover-services",
        build: (options) => interpolatePath("/discover-services", undefined, options?.search, options?.hash),
    },
    ServiceDefinitionsRoute: {
        to: "/discover-services/definitions",
        build: (options) => interpolatePath("/discover-services/definitions", undefined, options?.search, options?.hash),
    },
    ServiceDefinitionDetailRoute: {
        to: "/discover-services/definitions/:slug",
        build: (options) => interpolatePath("/discover-services/definitions/:slug", options.params, options?.search, options?.hash),
    },
    ServiceOfferingsRoute: {
        to: "/discover-services/offerings",
        build: (options) => interpolatePath("/discover-services/offerings", undefined, options?.search, options?.hash),
    },
    ServiceOfferingDetailRoute: {
        to: "/discover-services/offerings/:id",
        build: (options) => interpolatePath("/discover-services/offerings/:id", options.params, options?.search, options?.hash),
    },
    PermissionManagementRoute: {
        to: "/admin/permissions",
        build: (options) => interpolatePath("/admin/permissions", undefined, options?.search, options?.hash),
    },
    ApprovalDashboardRoute: {
        to: "/admin/approvals",
        build: (options) => interpolatePath("/admin/approvals", undefined, options?.search, options?.hash),
    },
    RecycleBinRoute: {
        to: "/admin/recycle-bin",
        build: (options) => interpolatePath("/admin/recycle-bin", undefined, options?.search, options?.hash),
    },
    AdminCanadaRoute: {
        to: "/admin/canada",
        build: (options) => interpolatePath("/admin/canada", undefined, options?.search, options?.hash),
    },
    AdminFeedbackRoute: {
        to: "/admin/feedback",
        build: (options) => interpolatePath("/admin/feedback", undefined, options?.search, options?.hash),
    },
    InformationDeskRoute: {
        to: "/information-desk",
        build: (options) => interpolatePath("/information-desk", undefined, options?.search, options?.hash),
    },
    OrgInformationDeskRoute: {
        to: "/org/:slug/information-desk",
        build: (options) => interpolatePath("/org/:slug/information-desk", options.params, options?.search, options?.hash),
    },
    NotFoundRoute: {
        to: "*",
        build: (options) => interpolatePath("*", options.params, options?.search, options?.hash),
    },
};
// PUBLIC API
export { Link } from './Link';
//# sourceMappingURL=index.js.map